import getXyManagePathPrefix from '@/utils/getXyManagePathPrefix';
const cacheMap = new Map();
// @ts-ignore
if (!window.__wuji_request_cacheMap__) {
    Object.defineProperty(window, '__wuji_request_cacheMap__', {
        value: cacheMap,
        enumerable: false,
    });
}
export function clearRequestCache() {
    cacheMap.clear();
}
export async function requestWithCache(options, request) {
    const { collectionId, projectId, envId, simplifyCgiSchema = true, refreshCache = false, } = options;
    const cacheKey = getCacheKey(collectionId, projectId, envId, simplifyCgiSchema);
    if (!cacheMap.has(cacheKey) || refreshCache) {
        const promise = request(options);
        cacheMap.set(cacheKey, promise);
    }
    return await cacheMap.get(cacheKey);
}
function getCacheKey(collectionId, projectId, envId, simplifyCgiSchema) {
    const simplifyString = simplifyCgiSchema ? 'simplify' : 'notSimplify';
    // 确定最终的env和branch
    const prefix = getXyManagePathPrefix({ envId });
    return [projectId, collectionId, prefix, simplifyString].join('/');
}
